<template>
  <div class="shoplist">
    <div class="retail_head">
      <img src="../assets/img/storage_bgc.png" />
      <div class="retail_head_shadow"></div>
    </div>
    <div class="sreach">
      <input type="text" v-model="key" />
      <button @click="sreachKey">{{ $t('locale.search') }}</button>
    </div>
    <div>
      <ul class="select">
        <li class="select-list">
          <dl id="select2">
            <dt>{{ $t('locale.tags') }}：</dt>
            <dd v-for="(item,index) in tags" :key="item" @click="selectTags(item,index)">
              <a :class="tagactiove == index ?'isActive' : ''">{{ item }}</a>
            </dd>
          </dl>
        </li>
        <li class="select-list">
          <dl id="select1">
            <dt>{{ $t('locale.categories') }}：</dt>
            <!-- <dd class="select-all isActive"><a href="#">全部</a></dd> -->
            <dd
              v-for="(item,index)  in categories"
              @click="selectSategories(item.name,item.category,index)"
              :key="item.id"
            >
              <!-- <template slot-scope="scope">
            <el-tag v-if="scope.row.roles.find(obj=>obj==='super_admin')">超级管理员</el-tag>
            <el-tag v-else>管理员</el-tag>
              </template>-->
              <a :class="actiove == index ?'isActive' : ''">{{ item.name }}</a>
            </dd>
          </dl>
        </li>
        
        <li v-cloak :class="list!=undefined?'isShow':' isNone'">
          <dl>
            <dt>{{ $t('locale.category_c') }}：</dt>
            <dd @click="selectList(item,index)" v-for="(item,index) in list" :key="item.id">
              <a :class="listactiove == index ?'isActive' : ''">{{ item.name }}</a>
            </dd>
          </dl>
        </li>
      </ul>
    </div>
    <div class="ban">
      <div class="sort">
        <dd v-for="(item,index) in options" @click="selectSort(item.value,index)">
          <a :class="sortiove == index ?'isActive' : ''">{{item.label}}</a>
        </dd>
      </div>
    </div>

    <div class="ban">
      <div class="shop_navlist">
        <li v-for="item in goodslist.slice(0, 12)" :key="item.id" >
          <a :href="'goodsdetail.html?id='+ item.id" target="_blank">
          <div class="shop_navlist_img">
            <img class="imgshadow" :src="item.detail.coverImg | uploadUrl" :scale="3" alt />
            <!-- <pic-zoom :url="item.icon" :scale="3"></pic-zoom>
            <img-zoom :src="item.icon" width='282px' heigth='300px' :bigsrc="item.icon" :configs="configs"></img-zoom>-->
          </div>
          <div class="shop_navlist_text">
            <span>{{item.type.categoryName+'-'}}</span>
            <span>{{item.name}}</span>
          </div>
          <div class="shop_navlist_price">
            <span>{{'¥'+item.price}}</span>
          </div>
          </a>
        </li>
      </div>
    </div>
    <el-pagination
      class="pag"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="Queryinfo.pagenum"
      :page-sizes="[12]"
      :page-size="Queryinfo.pagesize"
      layout="total, prev, pager, next, jumper"
      :total="total"
      font-size="18px !important"
    ></el-pagination>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "cell",
  data() {
    return {
      options: [
        { label: this.$i18n.t("locale.sort.default1"), value: "default" },
        { label: this.$i18n.t("locale.sort.priceAsc"), value: "priceAsc" },
        { label: this.$i18n.t("locale.sort.priceDesc"), value: "priceDesc" }
      ],
      categories: [],
      tags: [],
      goodslist: [],
      categoryTypes: {},
      list: [],
      // 已选择的一级分类
      Rescategories: "",
      // 已选择的一级tag
      Rescatag: "",
      // 当前索引值
      actiove: 0,
      tagactiove: 0,
      sortiove: 0,
      listid: "",
      listactiove: "-1",
      display: true,
      key: "",
      reorder: "",
      keyValue: "",
      total: 0,
      Queryinfo: {
        type: 10,
        // 当前的页码
        pagenum: 1,
        // 每页显示几条数据
        pagesize: 12
      }
    };
  },

  mounted() {},
  methods: {
    // 获取品类
    getCategories: async function() {
      const res = await this.$http.get(
        "/api/category/all"
      );
      let text = {
        id: 4,
        name: this.$i18n.t("locale.all")
      };
      let tag = this.$i18n.t("locale.all");
      res.data.tags.unshift(tag);
      var a = res.data.categories;
      a.unshift(text);
      this.categories = res.data.categories;
      this.tags = res.data.tags;
      this.categoryTypes = res.data.categoryTypes;
    },
    // 获取商品列表
    getGoodslist: async function() {
      const res = await this.$http.get(
        "/api/category/goods/list",
        {
          params: {
            page: this.Queryinfo.pagenum,
            key: this.keyValue,
            category: this.Rescategories,
            tag: this.Rescatag,
            typeId: this.listid,
            sort: this.reorder
          }
        }
      );
      this.total = res.data.paginator.count;
      this.goodslist = res.data.goods;
    },
    selectSategories: function(item, category, index) {
      this.Rescategories = category;
      this.keyValue = "";
      this.key = "";
      this.list = [];
      this.listid = ''
      this.listactiove = "-1";
      if (item == this.$i18n.t("locale.all")) {
        item = "";
      }
      this.list = this.categoryTypes[category];
      this.actiove = index;
      this.getGoodslist();
    },
    selectTags: async function(item, index) {
      this.keyValue = "";
      this.key = "";
      if (item == this.$i18n.t("locale.all")) {
        item = "";
      }
      this.Rescatag = item;
      this.tagactiove = index;
      this.getGoodslist();
    },
    selectList: function(item,index) {
      if (item.name == this.$i18n.t("locale.all")) {
        item.id = "";
      }
      this.listid = item.id;
      this.listactiove = index;
      this.getGoodslist();
    },
    selectSort: function(item, index) {
      this.reorder = item;
      this.sortiove = index;
      this.getGoodslist();
    },
    // Gooddetail: function(id) {
    //   // window.location.href = this.HTTPLOCAT + '/goodslist.html?id='+id
    //   window.location.href = "goodsdetail.html?id=" + id;
    // },
    sortblock: function() {
      this.display = !this.display;
    },
    sortChange: function() {
      this.reorder = this.sort;
      this.getGoodslist();
      this.display = !this.display;
    },
    sreachKey: function() {
      this.keyValue = this.key;
      this.getGoodslist();
    },
    handleSizeChange: function(newsize) {
      this.Queryinfo.pagesize = newsize;
      this.getGoodslist();
    },
    // 分页 监听 pagenum 改变
    handleCurrentChange: function(newnum) {
      this.Queryinfo.pagenum = newnum;

      this.getGoodslist();
    }
  },
  created() {
    this.getCategories();
    this.getGoodslist();
    this.list = undefined;
  },
  beforeCreate() {},
  computed: {
    // ...是否禁用上一页
    show: function() {
      return this.pages && this.pages != 1;
    },
    // 开始
    starts: function() {
      return this.current_page == 1;
    },
    ends: function() {
      return this.current_page == this.pages;
    },
    // ...
    efont: function() {
      if (this.pages <= 7) return false;
      return this.current_page > 5;
    },
    // 是否大于7
    ebehind: function() {
      if (this.pages <= 7) return false;
      var nowAy = this.indexs;
      return nowAy[nowAy.length - 1] != this.pages;
    },
    indexs: function() {
      var left = 1,
        right = this.pages,
        ar = [];
      if (this.pages >= 7) {
        if (this.current_page > 5 && this.current_page < this.pages - 4) {
          left = Number(this.current_page) - 2;
          right = Number(this.current_page) + 2;
        } else {
          if (this.current_page <= 5) {
            left = 1;
            right = 7;
          } else {
            right = this.pages;
            left = this.pages - 6;
          }
        }
      }
      while (left <= right) {
        ar.push(left);
        left++;
      }
      return ar;
    }
  }
};
</script>
<style scoped>
.ban {
  width: 1200px;
  margin: 0 auto;
}
.el-input--suffix .el-input__inner {
  border: 0 !important;
}
.retail_head {
  position: relative;
  width: 100%;
  height: auto;
}
.retail_head img {
  width: 100%;
  height: 100%;
  vertical-align: bottom;
}
.swiper-slide img {
  width: 1000px;
  height: 646px !important;
}
.retail_head_shadow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(155, 155, 155, 0.13);
  display: flex;
  justify-content: center;
  align-items: center;
}
.continer {
  width: 100%;
  height: 100%;
  background-color: #ccc;
  margin: 0;
}
dd {
  margin-left: 0;
}
ul {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
.shoplist {
  width: 100%;
  overflow: hidden;
  background:rgba(244,244,244,1);
}
.sreach {
  width: 380px;
  height: 42px;
  margin: 0 auto;
  margin-top: 23px;
  margin-bottom: 21px;
}
.sreach input {
  float: left;
  width: 302px;
  height: 42px;
  border: 0;
  outline: none;
  background: rgba(216, 216, 216, 0.28);
  font-size: 24px;
}
.sreach button {
  width: 72px;
  height: 44px;
  border: 0;
  background: rgba(204, 74, 73, 1);
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 30px;
  outline: 0;
  cursor: pointer;
}
.select {
  border-radius: 4px;
  width: 1200px;
  margin: 0 auto;
  font-size: 12px;
}
.select li {
  list-style: none;
  padding: 10px 0 5px 100px;
}
.select .select-list {
  border-bottom: #eee 1px solid;
}
.select dl {
  zoom: 1;
  position: relative;
  line-height: 24px;
}
.select dl:after {
  content: " ";
  display: block;
  clear: both;
  height: 0;
  overflow: hidden;
}
.select dt {
  width: 100px;
  margin-bottom: 5px;
  position: absolute;
  top: 0;
  left: -100px;
  text-align: right;
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}
.select dd {
  float: left;
  display: inline;
  margin: 0 0 5px 5px;
}
.select dd a {
  font-size: 18px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 27px;
}
.select a {
  display: inline-block;
  white-space: nowrap;
  height: 24px;
  padding: 0 10px;
  text-decoration: none;
  color: #039;
  border-radius: 2px;
  cursor: pointer;
}
/* .select a:hover {
  color: #f60;
  background-color: #f3edc2;
} */
.isActive {
  color: #cc4a49 !important;
}
.isShow {
  visibility: visible;
}
.isNone {
  visibility: hidden;
}
.disShow {
  display: block;
}
.disNone {
  display: none;
}
.sort {
  position: relative;
  font-size: 18px !important;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(102, 102, 102, 1) !important;
  line-height: 27px;
  margin-left: 26px;
  display: flex;
  margin: 10px auto;
  padding-left: 26px;
}
.sort dt {
  font-size: 18px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 27px;
}
.sort dd a {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 27px;
  margin-left: 15px;
  cursor: pointer;
}
/* .sort:hover .sortText{
  display: block !important;
} */
.sort button {
  width: 90px;
  border: 0;
  outline: 0;
}
.sort i {
  position: absolute;
  top: 10px;
  right: 0;
  display: block;
  width: 10px;
  height: 10px;
  background: url(../assets/img/Triangle.png) no-repeat;
}
.sortText {
  position: absolute;
  top: 30px;
  left: 86px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 4px 0px rgba(88, 88, 88, 0.5),
    0px -1px 4px 0px rgba(99, 99, 99, 0.5);
  border: 1px solid rgba(255, 255, 255, 1);
  outline: 0;
  border: 0;
}
.shop_navlist {
  width: 1224px;
  overflow: hidden;
}
.shop_navlist li {
  float: left;
  width: 282px;
  /*height: 400px;*/
  margin-right: 24px;
  margin-top: 23px;
  overflow: hidden;
  cursor: pointer;
}
.shop_navlist li .shop_navlist_img {
  width: 282px;
  height: 300px;
  overflow: hidden;

}
.shop_navlist_img img {
  width: 100%;
  height: 100%;
}
.shop_navlist_text {
  margin: 25px 0 10px 0;
}
.shop_navlist_text {
  text-align: left;
}
.shop_navlist_text span {
  font-size: 18px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 27px;
}
.shop_navlist_price {
  text-align: left;
}
.shop_navlist_price span {
  font-size: 22px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(204, 74, 73, 1);
  line-height: 33px;
}

.pag{
  margin-top: 20px;
  margin-bottom: 50px;
  font-size: 18px !important;
  background:rgba(244,244,244,1) !important;
}
.pag >>> .el-pager li.active {
  color: rgba(204, 74, 73, 1) !important;
}
.pag >>> .el-pagination__total{
  font-size: 18px !important;
}
.pag >>> .el-input__inner{
  font-size: 16px !important;
  outline: none !important;
}
.pag >>> .el-input__inner{
  border-color: rgba(102, 102, 102, 1) !important;
  background:rgba(244,244,244,1) !important;
}
.pag >>> .el-input__inner:focus{
      border-color: rgba(102, 102, 102, 1) !important;
}
.pag >>> .el-pagination button:disabled,.el-pager,.el-pagination .btn-next,.el-pagination .btn-prev {
  background:rgba(244,244,244,1) !important;
}
.pag >>> .btn-next {
  background:rgba(244,244,244,1) !important;
}
.pag >>> .btn-prev {
  background:rgba(244,244,244,1) !important;
}
.pag >>> .selected{
  color: rgba(204, 74, 73, 1) !important;
  font-size: 16px !important;
}
.pag >>> .el-pager li{
  font-size: 16px !important;
  background:rgba(244,244,244,1) !important;
}
.pag >>> .el-pagination__jump{
  font-size: 16px !important;
}
.imgshadow:hover{
   transform: scale(1.1);
  transition: all 1s;
  box-shadow: 0 50px 45px  #000;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/goods.vue